import { render, staticRenderFns } from "./ReBtn.vue?vue&type=template&id=7584bb0b&"
import script from "./ReBtn.vue?vue&type=script&lang=js&"
export * from "./ReBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports